import React from 'react';
import { useDreamscape } from '../contexts/DreamscapeContext';

/**
 * Full-screen fixed background with crossfade between time-of-day images
 * and a theme-matched overlay for text legibility.
 */
const DreamscapeBackground: React.FC = () => {
  const { backgroundUrl, nextBackgroundUrl, blend, timeOfDay } = useDreamscape();

  const isDay = timeOfDay === 'morning' || timeOfDay === 'afternoon';

  return (
    <div className="fixed inset-0" aria-hidden="true" style={{ pointerEvents: 'none', zIndex: 0 }}>
      {/* Current background layer */}
      {backgroundUrl && (
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${backgroundUrl})`,
            opacity: 1 - blend,
            transition: 'opacity 2s ease',
          }}
        />
      )}

      {/* Next background layer (for crossfade during transitions) */}
      {nextBackgroundUrl && blend > 0 && (
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${nextBackgroundUrl})`,
            opacity: blend,
            transition: 'opacity 2s ease',
          }}
        />
      )}

      {/* Overlay for text legibility */}
      <div
        className="absolute inset-0"
        style={{
          background: isDay ? 'rgba(245, 240, 232, 0.20)' : 'rgba(26, 20, 38, 0.25)',
          transition: 'background 1s ease',
        }}
      />
    </div>
  );
};

export default DreamscapeBackground;
